export default {
  headerContent: {
    title: 'Türk Nippon Sigorta İş Yeri Sigortası Hesaplama',
    slogan: "İş Yeri Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'İŞ YERİ SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türk Nippon Sigorta İş Yeri Sigortası',
    description: {
      title: 'Türk Nippon Sigorta İş Yeri (Paket) Sigortası Nedir? ',
      content: [
        'Türk Nippon Sigorta iş yeri sigortası ile işletmenizin normal akışı sırasında meydana gelebilecek kazalardan kaynaklı kayıplarınızı koruma altına almaktadır.',
        'İş yeri sigortası dahili su, yer kayması, fırtına, yangın ve hırsızlık gibi birçok riske karşı güvence sağlamaktadır. İş yeri sigortasının sağlamış olduğu bu güvence ile yeni yatırımlara yönelebilirsiniz.'
      ]
    },
    subContent: {
      title: 'Türk Nippon Sigorta İş Yeri (Paket) Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph: 'İş yeri sigortası teminatları 2 ye ayrılmaktadır.',
          subList: null
        },
        {
          paragraph: '<strong>Ana teminatlar:</strong>',
          subList: [
            'Yangın, Yıldırım, İnfilak',
            'Dahili Su',
            'Fırtına',
            'Yer Kayması',
            'Kara Ve Hava Taşıtları Çarpması',
            'Duman',
            'Kar Ağırlığı',
            'Grev, Lokavt, Karmaşa Halk Hareketleri, Kötü Niyetli Hareketler Ve Terör',
            'Dahili Dekorasyon',
            'Yangın Mali Sorumluluk',
            'Geçici İkametgah Değişikliği Masrafları',
            'Enkaz Kaldırma Masrafları',
            'Türk Nippon Asistans Hizmetleri (İşyeri)',
            'Onkoloji Destek',
            'Acil Tıbbi Yardım'
          ]
        },
        {
          paragraph: '<strong>Ek teminatlar:</strong>',
          subList: [
            'Deprem',
            'Sel Ve Su Baskını',
            'Hırsızlık',
            'İş Durması',
            'Kira Kaybı',
            'Kişisel Eşyalar',
            'Cam Kırılmaları',
            'Ferdi Kaza',
            '3. Şahıs Mali Sorumluluk',
            'İşveren Mali Sorumluluk',
            'Taşınan Para',
            'Emniyeti Suiistimal',
            'Elektronik Cihaz',
            'Makina Kırılması',
            'Kasa Hırsızlık',
            'Sabit Kıymet Hırsızlık',
            'Çalışanlara Ait Eşyalar',
            'İşveren Mali Mesuliyet',
            '3. Şahıs Mali Mesuliyet',
            'Ferdi Kaza',
            'Taşınan Para',
            'Emniyeti Suiistimal'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'İş Yeri Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'İş Yeri Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'İş Yeri Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türk Nippon Sigorta İş Yeri Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
